import { Button, ExternalLinkIcon } from "@theprelude/ds";

export const ExportDisabled = () => (
  <div className="flex items-center gap-1">
    Data export is a premium feature.
    <Button
      intent="text-link"
      icon={<ExternalLinkIcon className="text-secondary-foreground" />}
      onClick={() => {
        window.open(
          "https://www.preludesecurity.com/thank-you/book-a-demo",
          "_blank",
        );
      }}
      className="p-0"
    >
      Talk to sales
    </Button>
  </div>
);
